import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router';
import { useBreadcrumbs, type Crumb } from '@/shell/breadcrumbs';

type NavKey = 'dashboard' | 'organizations' | 'sites' | 'library' | 'plans' | 'settings' | 'audit';

/** Stands in for a screen that a later task builds (see planning/phases). */
export function Placeholder({ screen, nav }: { screen: string; nav?: NavKey }) {
  const params = useParams();
  const { pathname } = useLocation();
  const { t } = useTranslation('shell');
  const crumbs: Crumb[] = nav ? [{ label: t(`nav.${nav}`) }] : [{ label: screen }];
  useBreadcrumbs(crumbs);
  return (
    <div data-placeholder={screen}>
      <h1 style={{ margin: 0, fontSize: 40, fontWeight: 600, letterSpacing: '-.035em' }}>{nav ? t(`nav.${nav}`) : screen}</h1>
      <p style={{ color: '#85858B', fontSize: 13, fontFamily: "'Geist Mono',monospace" }}>
        {pathname} {Object.keys(params).length ? JSON.stringify(params) : ''}
      </p>
    </div>
  );
}

/** Placeholder outside the shell (no breadcrumbs). */
export function BarePlaceholder({ screen }: { screen: string }) {
  return (
    <div data-placeholder={screen} style={{ padding: 28 }}>
      <h1 style={{ margin: 0, fontSize: 40, fontWeight: 600 }}>{screen}</h1>
    </div>
  );
}
